/**
 * 🌲 TaxonomyReportService
 * Generates the "Pre-Flight" RTF Audit Report
 * Location: src/registered/site-admin/components/Workflow-esg/services/generateTaxonomyRTF.js
 */
import { runTaxonomyTrawl } from "../controllers/TaxonomyTrawlerController";

export const generateTaxonomyRTF = (selectedFile, results) => {
  const now = new Date().toLocaleString();

  // 🎯 FIX 1: Run the Trawl on the fly or pull from results if already calculated
  // Your UI uses runTaxonomyTrawl(results.worksheets), so we do the same here.
  const stats = results?.worksheets ? runTaxonomyTrawl(results.worksheets) : [];

  // 🎯 FIX 2: Pathing to Meta (Nesting check)
  // schemaBuilder.js returns { concepts, roots, meta: { ... } } inside esgTree
  const meta = results?.esgTree?.meta || results?.meta || {};

  // RTF Header and Font Table
  let rtf = "{\\rtf1\\ansi\\deff0 {\\fonttbl {\\f0 Arial;}} \\f0\\fs24 ";
  
  // Title Section
  rtf += "{\\b\\fs32 ESRS TAXONOMY PRE-FLIGHT AUDIT} \\par \\line ";
  rtf += `{\\b Source Asset:} ${selectedFile?.filename || "Unknown Asset"} \\par `;
  rtf += `{\\b Run Date:} ${now} \\par \\line `;

  // SECTION 1: PHYSICAL RECONCILIATION
  rtf += "{\\b 1. PHYSICAL RECONCILIATION (SQL STAGING PREVIEW)} \\par \\line ";
  rtf += "\\trowd\\trgaph108\\trleft-108 ";
  rtf += "\\clbrdrt\\brdrs\\brdrw10 \\clbrdrl\\brdrs\\brdrw10 \\clbrdrb\\brdrs\\brdrw10 \\clbrdrr\\brdrs\\brdrw10 \\cellx3000 ";
  rtf += "\\clbrdrt\\brdrs\\brdrw10 \\clbrdrl\\brdrs\\brdrw10 \\clbrdrb\\brdrs\\brdrw10 \\clbrdrr\\brdrs\\brdrw10 \\cellx4500 ";
  rtf += "\\clbrdrt\\brdrs\\brdrw10 \\clbrdrl\\brdrs\\brdrw10 \\clbrdrb\\brdrs\\brdrw10 \\clbrdrr\\brdrs\\brdrw10 \\cellx6000 ";
  rtf += "\\clbrdrt\\brdrs\\brdrw10 \\clbrdrl\\brdrs\\brdrw10 \\clbrdrb\\brdrs\\brdrw10 \\clbrdrr\\brdrs\\brdrw10 \\cellx7500 ";
  rtf += "{\\b Property} \\cell {\\b Unique} \\cell {\\b Total} \\cell {\\b MaxLen} \\cell \\row ";

  // 🎯 FIX 3: Iterate through stats generated from the worksheets
  stats.forEach(col => {
    rtf += `${col.ColumnName} \\cell ${col.UniqueValueCount} \\cell ${col.TotalOccurrences} \\cell ${col.MaxLength} \\cell \\row `;
  });

  rtf += "\\par \\line ";

  // SECTION 2: STRUCTURAL INTEGRITY
  rtf += "{\\b 2. STRUCTURAL INTEGRITY & LOGICAL MAPPING} \\par \\line ";
  rtf += `Total Concepts Identified: ${meta.conceptCount || 0} \\par `;
  rtf += `Root Chapters Detected: ${meta.rootCount || 0} \\par `;
  rtf += `Calculation Rules: ${meta.calculationRules || 0} \\par `;
  rtf += `Dimension Pairs: ${meta.dimensionPairs || 0} \\par \\line `;

  rtf += "{\\i Note: This report validates the local Discovery Pass. Actual SQL ingestion will be performed by the Python Lambda service.} \\par ";
  rtf += "}";

  return rtf;
};